import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { FormValidator, FormValidatorModel } from "@syncfusion/ej2-vue-inputs";
import { onMounted, ref } from "vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  validations?:SogFormValidationRule[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogForm',
  props: {
    validations: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {


const props = __props


const form = ref<HTMLFormElement|undefined>(undefined)

const options: FormValidatorModel = {
  customPlacement: function(inputElement, errorElement) {
    const inputErrorElement = inputElement.closest('.sog-form-field').querySelector('.error');
    inputErrorElement.parentElement.appendChild(errorElement);
  },
  rules:{
    //'Name':{    required: true}
  }
}

let formValidator : FormValidator|undefined = undefined

const validate = ( ):boolean => {
  if(formValidator)
    return formValidator.validate();
  return false;
}

const addRules = (rule:SogFormValidationRule)=>{
      formValidator?.addRules(rule.name, rule.rules)
}

const removeRules = (name:string)=>{
    formValidator?.removeRules(name)
}


onMounted(()=>{
  if(form.value) {
    formValidator = new FormValidator(form.value, options);

    if (props.validations && props.validations.length>0) {
      props.validations.forEach(v => {
        formValidator?.addRules(v.name, v.rules)
      })
    }

  }
})


__expose({
  validate,addRules,removeRules
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    ref_key: "form",
    ref: form
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})